import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

// The back-end rejects a 0 or missing requested amount, so fall back to an arbitrary default (FIN-17936).
const DEFAULT_FINANCED_AMOUNT = 5000;

export interface FinancedAmountState {
    saleAmount: number;
    downPayment: number;
}

function useFinancedAmount(
    initialState: FinancedAmountState = { saleAmount: 1000, downPayment: 0 },
) {
    const [{ saleAmount, downPayment }, setFinancedAmount] =
        useState<FinancedAmountState>(initialState);

    return {
        get financedAmount() {
            const amount = saleAmount - downPayment;
            return amount === 0 || Number.isNaN(amount) ? DEFAULT_FINANCED_AMOUNT : amount;
        },
        saleAmount,
        downPayment,
        setFinancedAmount,
    };
}

export const FinancedAmountStore = createStore(useFinancedAmount);
